function textToChars(text: string) {
  return text.split('').map((c: string) => c.charCodeAt(0))
}

function byteHex(n: any) {
  return ('0' + Number(n).toString(16)).slice(-2)
}

function applySaltToChar(code: any, salt: string) {
  return textToChars(salt).reduce((a: number, b: number) => a ^ b, code)
}

function isHexString(value: string): boolean {
  return /^[0-9a-fA-F]*$/.test(value) && value.length % 2 === 0
}

export const crypt = {
  byteHex,
  textToChars,
  applySaltToChar,
  isHexString,
  encrypt(salt: any, text: string) {
    try {
      return text
        .split('')
        .map(textToChars)
        .map((code: any) => applySaltToChar(code, salt))
        .map(byteHex)
        .join('')
    } catch {
      return text
    }
  },
  decrypt(salt: string, encoded: string) {
    try {
      return encoded
        .match(/.{1,2}/g)!
        .map((hex: string) => parseInt(hex, 16))
        .map((code: any) => applySaltToChar(code, salt))
        .map((charCode: number) => String.fromCharCode(charCode))
        .join('')
    } catch {
      return encoded
    }
  }
}
